import { gql, useQuery } from "@apollo/client";
import React from "react";
import { HandleQuery } from "../../queries";

// Assume a Focal Point has been set, it is the responsibility of the parent to tell us differently
const ImgixFluidImage = ({ 
    image, 
    ar = 1.33333, 
    focalPoint, 
    sizes = "100vw", 
    hasFocalPoint = true, 
    fit = 'crop', 
    alt="image", 
    attribution, 
    className = "",
    width = 1280,
    height = null,
    caption = false,
}) => {

    var x = "center";
    var y = "center";

    if(focalPoint && focalPoint.length == 2)
    {
        x = focalPoint[0] >= 0.75 ? "right" : (focalPoint[0] <= 0.25 ? "left" : "center");
        y = focalPoint[1] >= 0.75 ? "bottom" : (focalPoint[1] <= 0.25 ? "top" : "center");
    }

    const query_state = useQuery(gql`
        query 
        {
            asset(id: ${image.id}) @transform(format: "webp", width: ${width}, ${height ? `height: ${height}, ` : `height: ${parseInt(width / ar)}, `}mode: "${fit}", quality: 75, position: "${y}-${x}")
            {
                url
            }
        }
    `);

    const { complete, view } = HandleQuery(query_state);
    if(!complete) return view;
    const data = query_state.data; 

    return (
        <div className={`relative w-full h-full min-h-[170px] ${caption ? "mb-8" : ""}`} style={{aspectRatio: ar}}>
            <img className={className} sizes={sizes} src={"https://cms.genesis-analytics.com" + data.asset.url} alt={alt}/>
            {attribution ?  <span className="absolute bottom-2 right-1 opacity-50" style={{fontSize: "10px"}}>{attribution}</span> : <></>}
            {caption && <figcaption className="text-xs text-gray-600 px-1 pt-2" dangerouslySetInnerHTML={{ __html: caption }}/>}
        </div>
    );
};

export default ImgixFluidImage;
